module.exports = __webpack_public_path__ + "media/images/emblems/Graben-coat_of_arms-405930d8b97bd1d5b60de851ccc4e5fa.svg";